import { render, staticRenderFns } from "./service-view-toolbar.vue?vue&type=template&id=a64864c6&"
import script from "./service-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./service-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports